import { createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../../contracts";
import { TutoringType } from "../../contracts/enums";
import { Tutoring } from "../../contracts/tutoring/dto";
import { useCourse } from "../course";
import { useVideoPlayer } from "../videoPlayer";

type TutoringContextData = {
    tutoringList: Tutoring[],
    monitoringList: Tutoring[],
    getTutoringList: () => Promise<Tutoring[]>,
    getMonitoringList: () => Promise<Tutoring[]>,
    changeTutoringList: (list: Tutoring[]) => void,
    changeMonitoringList: (list: Tutoring[]) => void
}

const DEFAULT: TutoringContextData = {
    tutoringList: [],
    monitoringList: [],
    getTutoringList: () => Promise.resolve<Tutoring[]>([]),
    getMonitoringList: () => Promise.resolve<Tutoring[]>([]),
    changeTutoringList: () => { },
    changeMonitoringList: () => { }
};

const TutoringContext = createContext(DEFAULT);

export const TutoringProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();
    const { setConfig } = useVideoPlayer();

    const [tutoringList, setTutoringList] = useState<Tutoring[]>([]);
    const [monitoringList, setMonitoringList] = useState<Tutoring[]>([]);

    const getTutoringList = useCallback(async () => {
        const response = await api.tutoring.getList(type, TutoringType.tutoring);
        setTutoringList(response);

        return response;
    }, [type]);

    const changeTutoringList = useCallback((list: Tutoring[]) => {
        setTutoringList([...list]);
    }, []);

    const getMonitoringList = useCallback(async () => {
        const response = await api.tutoring.getList(type, TutoringType.monitoring);
        setMonitoringList(response);

        return response;
    }, [type]);

    const changeMonitoringList = useCallback((list: Tutoring[]) => {
        setMonitoringList([...list]);
    }, []);

    useEffect(() => {
        setConfig({
            labelNext: 'Próxima Aula',
            labelPrevius: 'Aula Anterior'
        });
    }, [setConfig])


    return (
        <TutoringContext.Provider
            value={{
                tutoringList,
                monitoringList,
                getTutoringList,
                getMonitoringList,
                changeTutoringList,
                changeMonitoringList
            }}>
            {children}
        </TutoringContext.Provider>
    );
}

export function useTutoring(): TutoringContextData {
    const context = useContext(TutoringContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}